import axiosInstance from "../../../utils/axios";
import { objToURL } from "../../../utils/commonfunction";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/user-management/club-admin"

export const List = async (values) => {
    return await axiosInstance(options).get(`${path}/list${objToURL (values)}`);
}

export const Edit = async (values,id) => {
    return await axiosInstance(options).put(`${path}/${id}`, values);
}

export const Delete = async (values) => {
    return await axiosInstance(options).delete(`${path}/${values}`)
}

export const profileVerify = async (values,id) => {
    return await axiosInstance(options).put(`${path}/profile-verified/${id}`,values)
}

export const Details  = async (id) => {
    return await axiosInstance(options).get(`${path}/${id}`);
}

export const Status = async (values,id) => {
    return await axiosInstance(options).patch(`${path}/status/${id}`, values)
}

export const blockUser = async (values, id) => {
    return await axiosInstance(options).put(`${path}/block/${id}`, values);
}


export const resendOnboardInvite = async (id, data = {}) => {
    const isFormData = typeof FormData !== "undefined" && data instanceof FormData;
    const config = isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {};
    return axiosInstance(options).post(`${path}/resend-onboard-invite/${id}`, data, config);
};

export const changeClubType = async (values, id) => {
    return await axiosInstance(options).patch(`${path}/club-type/${id}`, values);
}

export const autoPaymentDeduct = async (id) => {
    return axiosInstance(options).post(`${path}/auto-deduct/${id}`);
};

export const chargeBilling = async (id) => {
    return axiosInstance(options).post(`${path}/charge-billing/${id}`);
};

export const chargeNextMonthBilling = async (id) => {
    return axiosInstance(options).post(`${path}/charge-next-month-billing/${id}`);
};

export const chargeAllBilling = async () => {
    return axiosInstance(options).post(`${path}/charge-all-billing`);
};

export const chargeAllNextMonthBilling = async () => {
    return axiosInstance(options).post(`${path}/charge-all-next-month-billing`);
};

export const extendTrial = async (values, id) => {
    return await axiosInstance(options).patch(`${path}/extend-trial/${id}`, values);
};

export const transferRole = async (id, values) => {
    return await axiosInstance(options).patch(`${path}/transfer-role/${id}`, values);
};

export const sendPendingInvoiceEmail = async (id) => {
    return axiosInstance(options).post(`${path}/send-pending-invoice-email/${id}`);
};

